export enum EPostbackStatus {
	Lead = 'lead',
	Sale = 'sale',
	Reject = 'reject',
}

export const POSTBACK_STATUS_LABEL_MAP: Record<EPostbackStatus, string> = {
	[EPostbackStatus.Lead]: `postback_status.${EPostbackStatus.Lead}`,
	[EPostbackStatus.Sale]: `postback_status.${EPostbackStatus.Sale}`,
	[EPostbackStatus.Reject]: `postback_status.${EPostbackStatus.Reject}`
}